<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import firebase from "firebase/compat/app";

export default {
  metaInfo: {
    changed(metaInfo) {
      firebase.analytics().setCurrentScreen(metaInfo.title);
      firebase.analytics().logEvent("page_view");
    },
  },
  watch: {
    "$store.state.auth.user"() {
      // Rebind the global Vuexfire when the user changes (e.g. when the user logs in or logs out).
      this.bindGlobalVuexfire();
    },
    "$vs.rtl"(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
    },
  },
  mounted() {
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    this.bindGlobalVuexfire();
  },
  created() {
    let dir = this.$vs.rtl ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);

    window.addEventListener("resize", this.handleWindowResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
  },
  methods: {
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

      // Set --vh property
      document.documentElement.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
    },
    bindGlobalVuexfire() {
      // Bind global firestore references with vuexfire.
      // This is needed, because sometimes we need firestore objects in different components
      // that can be initialised at the same time, but for some reason if we bind two at the
      // same time, one bind is getting stuck and never returns. Hence we need to bind them once
      // only and assume in our components that the bind has been called.
      this.$store.dispatch("customIndicators/bindCustomIndicatorsRef");
      this.$store.dispatch("portfolios/bindPortfoliosRef");
      this.$store.dispatch("userInfo/bindUserInfoRef");
    },
  },
};
</script>

<style>
/*
  Hide the default reCAPTCHA badge; disclose use of reCAPTCHA on pages where it runs (e.g. contact
  form).
*/
.grecaptcha-badge {
  visibility: hidden;
}
</style>
